import { useState } from "react";
import type { PlanFaq as PlanFaqItem } from "@/types/plans";

interface PlanFaqProps {
  faqs: PlanFaqItem[];
}

export default function PlanFaq({ faqs }: PlanFaqProps) {
  const [openId, setOpenId] = useState<string>(faqs[0]?.id ?? "");

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? "" : id));
  };

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-3">
      {faqs.map((faq) => {
        const isOpen = openId === faq.id;
        return (
          <div
            key={faq.id}
            className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
          >
            <button
              type="button"
              onClick={() => toggle(faq.id)}
              aria-expanded={isOpen}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                {faq.question}
              </span>
              <span
                className={`flex h-5 w-5 shrink-0 items-center justify-center text-foreground-500 transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              >
                <i className="ri-arrow-down-s-line text-xl" />
              </span>
            </button>
            {isOpen ? (
              <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                {faq.answer}
              </p>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}